import React from 'react';
import styled from 'styled-components';

const NotFoundStyles = styled.div`
height: 100vh;
overflow-y: auto;
border-left: 1px solid ${props => props.theme.border};
background-color: ${props => props.theme.bgColor_2};
h1{
    font-size: 50px;
    text-align: center;
    margin-bottom: 15px;
}
`;

const NotFound = () => {
    return(
        <NotFoundStyles className='d-flex flex-column justify-content-center'>
            <h1>404</h1>
            <p className="text-center">Trang không hợp lệ!</p>
        </NotFoundStyles>
    )
}

export default NotFound;